export const isXs = () => window.innerWidth < '767'